import React from 'react';
import ReactDOM from 'react-dom/client';
import Home from './Home';
import Login from './Login';
import Shop from './Shop';
import Bill from './Bill';
import Billdetails from './Billdetails';
import Editbill from './Editbill';
import Paymentshop from './Paymentshop';
import Logout from './Logout';
import Denomination from './Denomination';


import Signup from './Signup';
import Payment from './Payment';
import Product from './Product';
import Settings from './Settings';
import Transaction from './Transaction';
import Notification from './Notification';
import Bill2 from './Bill2';
import Customer from './Customer';
import CustomerEdit from './CustomerEdit';
import Workers from './Workers';
import WorkerEdit from './WorkerEdit';
import RecentBills from './RecentBills';
import AddPayment from './AddPayment';
import PaymentLedger from './PaymentLedger';
import Denominationcal from './Denominationcal';
import Denominationlist from './Denominationlist';
import Denominationlistcal from './Denominationlistcal';
import Denominationdetailsview from './Denominationdetailsview';


import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import { ConnectivityProvider } from './context/ConnectivityContext';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AuthProvider>
    <ConnectivityProvider>
      <QueryClientProvider client={queryClient}>
    <React.StrictMode>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/Logout" element={<Logout />} />

          
          <Route path="/Payment" element={<Payment />} />
          <Route path="/Product" element={<Product />} />
          <Route path="/Settings" element={<Settings />} />
          <Route path="/Transaction" element={<Transaction />} />
          <Route path="/Notification" element={<Notification />} />
          <Route path="/Shop" element={<Shop />} />
          <Route path="/Bill" element={<Bill />} />
          <Route path="/Billdetails" element={<Billdetails />} />
          <Route path="/Editbill" element={<Editbill />} />
          <Route path="/Paymentshop" element={<Paymentshop />} />
          <Route path="/Bill2" element={<Bill2 />} />
          <Route path="/customer" element={<Customer />} />
          <Route path="/customer/edit/:id" element={<CustomerEdit />} />
          <Route path="/workers" element={<Workers />} />
          <Route path="/worker/create" element={<WorkerEdit />} />
          <Route path="/worker/edit/:id" element={<WorkerEdit />} />
          <Route path="/recent-bills" element={<RecentBills />} />
          <Route path="/add-payment" element={<AddPayment />} />
          <Route path="/payment-ledger" element={<PaymentLedger />} />
          <Route path="/Denomination" element={<Denomination />} />
          <Route path="/Denominationcal" element={<Denominationcal />} />
          <Route path="/Denominationlist" element={<Denominationlist />} />
          <Route path="/Denominationlistcal" element={<Denominationlistcal />} />
          <Route path="/Denominationdetailsview" element={<Denominationdetailsview />} />
          
          
             <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />

        </Routes>
      </Router>
    </React.StrictMode>
    </QueryClientProvider>
    </ConnectivityProvider>
  </AuthProvider>
);

reportWebVitals();
